import { createContext } from "react";

export type LayoutStyle = "sidebar" | "legacy";

export interface LayoutStyleContextType {
  style: LayoutStyle;
  setStyle: (style: LayoutStyle) => void;
}

// Objeto de contexto isolado num .ts sem JSX, separado do Provider (componente)
// e do hook — mistura das três coisas num só arquivo quebrou o Fast Refresh de
// verdade (Vite recriava o createContext() ao invalidar o módulo, gerando uma
// segunda instância: Provider escrevia numa, hook lia da outra). Ver
// docs/migracao/diario.md, passo 0.4.4.
export const LayoutStyleContext = createContext<LayoutStyleContextType | undefined>(undefined);
